export const QR_BASE_URL = '/qr/';

export const QR_PARAMS = {
  TYPE: 'type',
  TENANT_ID: 'tenant_id',
} as const;

export const EQUIPMENT_REGISTRY_QR_PARAMS = {
  FROM_QR_CODE: 'from_qr_code',
  EQUIPMENT_ID: 'equipment_id',
} as const;

export const USER_TYPE_SEARCH_PARAM = 'user-type';

export const USER_TYPE = {
  NEW_GUEST: 'new_guest',
  GUEST: 'guest',
  EMPLOYEE: 'employee',
  VARICON_USER: 'user',
} as const;
